import { API_AUTH } from "./common";

const DanhSachCuaHangApi = {
  // list: ({
  //   dateFrom,
  //   dateTo,
  //   code,
  //   customerName,
  //   address,
  //   noteTaiSan,
  //   status,
  //   debt,
  //   userName,
  //   pageIndex,
  //   pageSize,
  // }) =>
  //   API_AUTH.get(
  //     `quanlychovay/danh-sach-cua-hang?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
  //     {},
  //   ),

  getListDanhSachCuaHang: ({ nameSearch, statusSearch }) => {
    return API_AUTH.get(
      `quan-ly-cua-hang/danh-sach-cua-hang1?tenCuaHang=${nameSearch}&trangThai=${statusSearch}`,
      {},
    );
  },
  list: ({
    sCode,
    sName,
    sAddress,
    sPhone,
    sStatus,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `Company/danhsachcuahang?pageIndex=${pageIndex}&pageSize=${pageSize}&sCode=${sCode}&sName=${sName}&sAddress=${sAddress}&sPhone=${sPhone}&sStatus=${sStatus}`,
      {}
    ),
  addorupdate: (data) => API_AUTH.post(`Company/addorupdate`, data),
  getNewCode: () => API_AUTH.get(`Company/getNewCode`, {}),
  ChiTietCuaHang: () => API_AUTH.get(`Company/ChiTietCuaHang`,{}),
  CuaHangHienTai: () => API_AUTH.get(`Company/getCurrentCompany`,{}),
  TongQuatCuaHang: () =>
    API_AUTH.get(`/Company/TongQuatCuaHang`, {}),
  getListCuaHang: () => API_AUTH.get("Company/ListCuaHang"),
};

export default DanhSachCuaHangApi;
